/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// French
export default {
  'fabric.atlassianSwitcher.switchTo': 'Passer à',
  'fabric.atlassianSwitcher.switchToTooltip': 'Passer à…',
  'fabric.atlassianSwitcher.recent': 'Récents',
  'fabric.atlassianSwitcher.more': 'Plus',
  'fabric.atlassianSwitcher.try': 'Essayer',
  'fabric.atlassianSwitcher.manageList': 'Gérer la liste',
  'fabric.atlassianSwitcher.jiraProject': 'Projet Jira',
  'fabric.atlassianSwitcher.confluenceSpace': 'Espace Confluence',
  'fabric.atlassianSwitcher.people': 'Personnes',
  'fabric.atlassianSwitcher.administration': 'Administration',
  'fabric.atlassianSwitcher.discoverMore': "Découvrir d'autres produits",
  'fabric.atlassianSwitcher.errorHeading': 'Une erreur est survenue',
  'fabric.atlassianSwitcher.errorText': 'Nous suivons ces erreurs, mais n’hésitez pas à nous contacter si elles persistent même après avoir actualisé la page.',
  'fabric.atlassianSwitcher.errorImageAltText': 'Plusieurs personnes occupées à réparer un robot cassé.',
  'fabric.atlassianSwitcher.expand': 'Découvrir'
};